<template>
    <div class="field" v-show="visible">
        <div class="field-selection-wrapper radio-selection-wrapper" :class="specialType">
            <question-attributes :colors="colors" :field="field"></question-attributes>
            <div class="field-selection-container radio-selection-container">
                <div
                        class="radio-selection field-option"
                        v-for="(option, idx) in field.answerOptions"
                        :key="field.id + '_' + idx"
                        :class="{selected: option.selected}"
                        :style="option.selected ? selectionStyle : {}"
                        @click="setStatus(option, idx)">
                    <div class="radio" :style="option.selected ? radioStyle : {}"></div>
                    <span class="label" :style="{color: colors.baseColor}">{{option.value}}</span>
                </div>
                <div class="error" v-if="field.invalid && !totalSelected">This field is required</div>
            </div>
        </div>
    </div>

</template>

<script>
    import Field from './Field'
    import {EventBus} from "survey-fields/src/EventBus";
    export default {
        name: 'RadioField',
        extends: Field,
        props: ['type', 'colors'],
        computed: {
            selectionStyle() {
                return {
                    borderColor: this.colors.highlightColor
                }
            },
            radioStyle() {
                return {
                    backgroundColor: this.colors.highlightColor,
                    border: 'solid 1px ' + this.colors.highlightColor
                }
            },
            specialType() {
                let classes = ''

                if (this.type) {
                    classes += 'special-type-' + this.type
                }

                return classes
            }
        },
        methods: {
            setStatus (option, itemIndex) {
                if (itemIndex === null) {
                    this.field.isNull = true
                } else {
                    this.field.isNull = false
                }
                this.field.answerOptions = this.field.answerOptions.map((item, index) => {
                    if (itemIndex == index) {
                        // In case of range inputs we allow the user to deselect his/her initial option
                        // Also allow deselecting radio buttons when question is optional
                        if ((this.field.type == 'range' || (this.field.type == 'radiobutton' && !this.field.required)) && item.selected === true) {
                            item.selected = false
                        } else {
                            item.selected = true
                        }
                    } else {
                        item.selected = false
                    }

                    EventBus.$emit('answerOptionIdClicked', JSON.stringify({answerOptionId: item.id, newValue: item.selected}))

                    return item
                })
            }
        }
    }
</script>

<style scoped>
    .radio-selection-container {
        display: flex;
        flex-wrap: wrap;
        position: relative;
    }
    .radio-selection {
        flex: 1 0 50%;
        width: 50%;
        max-width: calc(50% - 34px);
        margin: 0 10px 10px 0;
        border: solid 2px transparent;
        box-shadow: 0 0 4px rgba(0, 0, 0, 0.14);
        padding: 10px;
        border-width: 0;
        cursor: pointer;
        border: solid 2px #e6e6e6;
    }
    .radio-selection:nth-child(2n + 2) {
        margin-right: 0;
    }
    .radio-selection.selected {
        border-color: #00aef1;
        animation: border-flash 0.5s;
    }
    .radio {
        display: inline-block;
        vertical-align: middle;
        width: 28px;
        height: 28px;
        border: solid 1px #90919e;
        border-radius: 50%;
        margin-right: 10px;
        position: relative;
    }
    .radio-selection.selected .radio {
        border: solid 1px #00aef1;
    }
    .radio-selection.selected .radio:after {
        content: "";
        background: #fff;
        width: 11px;
        height: 11px;
        position: absolute;
        border-radius: 50%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .label {
        font-size: 13px;
        font-weight: 600;
    }
    .radio-selection-wrapper.special-type-yes_no .radio-selection .radio {
        background-repeat: no-repeat;
    }
    .radio-selection-wrapper.special-type-yes_no .radio-selection:first-child .radio {
        background-image: url('/survey-icons/sad.png');
    }
    .radio-selection-wrapper.special-type-yes_no .radio-selection:last-child .radio {
        background-image: url('/survey-icons/happy.png');
    }
</style>
